import i18n from '@/utils/i18n/i18n';

const moment = require('moment-jalaali');

function part1(RepeatEvery, type) {
  if (RepeatEvery === 1 || RepeatEvery === '1') {
    // eslint-disable-next-line prefer-template
    return `${i18n.t(type)}`;
    // eslint-disable-next-line no-else-return
  } else {
    // eslint-disable-next-line no-lonely-if
    if (type === 'daily') {
      return `${i18n.t('every')} ${RepeatEvery} ${i18n.t('days')}`;
      // eslint-disable-next-line no-else-return
    } else if (type === 'weekly') {
      return `${i18n.t('every')} ${RepeatEvery} ${i18n.t('weeks')} `;
    } else {
      return '';
    }
  }
}

function part2(RepeatOnDays, type) {
  const locale = localStorage.getItem('locale');
  if (RepeatOnDays && RepeatOnDays.length > 1 && RepeatOnDays.length < 7 && type === 'weekly') {
    // eslint-disable-next-line max-len
    const splicedDays = RepeatOnDays.map((day) => day.charAt(0).toUpperCase() + day.slice(1).substring(0, 2)).join(', ');
    const persianDays = RepeatOnDays.map((day) => i18n.t(`${day}`)).join(', ');
    return `${i18n.t('on_day')} ${locale === 'en' ? splicedDays : persianDays}`;
    // eslint-disable-next-line no-else-return
  } else if (RepeatOnDays && RepeatOnDays.length === 1) {
    const persianDays = RepeatOnDays.map((day) => i18n.t(`${day}`));
    return `${i18n.t('on_day')} ${persianDays}`;
  } else if (RepeatOnDays && RepeatOnDays.length === 7) {
    return `${i18n.t('on_day')} ${i18n.t('all')} ${i18n.t('days')}`;
  } else {
    return '';
  }
}

function textDirection(dir, str) {
  // eslint-disable-next-line prefer-template
  if (dir === 'rtl') return '\u202B' + str + '\u202C';
  // eslint-disable-next-line prefer-template
  return '\u202A' + str + '\u202C';
}
function part3(EndOn, EndType, EndAfter, calendar) {
  const END_REPEAT_DATE = calendar === 'Solar'
      ? moment(EndOn).format('jYYYY-jMM-jDD')
      : moment(EndOn).format('YYYY-MM-DD');
  if (EndType === 'end_on') {
    // eslint-disable-next-line prefer-template
    return `${i18n.t('until')} ` + textDirection('ltr', END_REPEAT_DATE);
    // eslint-disable-next-line no-else-return
  } else if (EndType === 'end_after') {
    return `${i18n.t('after')} ${EndAfter} ${i18n.t('repeat')}`;
  } else {
    return '';
  }
}
function customRepeatMessage(
  RepeatEvery,
  startHours,
  startMinutes,
  type,
  RepeatOnDays,
  EndOn,
  EndType,
  EndAfter,
  calendar,
) {
  return `${part1(RepeatEvery, type)} ${i18n.t(
    'at',
  )} ${startHours}:${startMinutes} ${part2(RepeatOnDays, type)} ${part3(
    EndOn,
    EndType,
    EndAfter,
    calendar,
  )}`;
}

export default customRepeatMessage;
